import React, { Fragment } from 'react'
import { Field, useFieldState } from 'formular'

import { Box } from 'components/_new/layout'
import { FieldError } from 'components/_new/forms'

import SelectableRatingField from 'compositions/form/SelectableRatingField/SelectableRatingField'


type RatingProps = {
  field: Field<Review.Rating>
  onChange?: (rating: Review.Rating) => void
}

const Rating: React.FunctionComponent<RatingProps> = ({ field, onChange }) => {
  const { error } = useFieldState(field)

  return (
    <Fragment>
      <SelectableRatingField field={field} size={24} withLabel onChange={onChange} />
      {
        Boolean(error) && (
          <Box mt={8}>
            <FieldError message={error} />
          </Box>
        )
      }
    </Fragment>
  )
}


export default Rating
